export default "__VITE_ASSET__KaxhrxYE__"